import type { ReactElement } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { IconButton } from "@similarweb/ui-components";

interface IProps {
    onClose: VoidFunction;
}

const LeadScoreTooltipCloseButton = ({ onClose }: IProps): ReactElement => {
    const { translate } = useTranslate();

    return (
        <IconButton
            dataAutomation="lead-score-tooltip-close"
            iconSize="xs"
            type="flat"
            iconName="clear"
            onClick={onClose}
            aria-label={translate("si.common.button.close")}
        />
    );
};

export default LeadScoreTooltipCloseButton;
